// extracted by mini-css-extract-plugin
module.exports = {"container":"CenterCard_container__2diG6","doctor":"CenterCard_doctor__3FjB-","circle":"CenterCard_circle__Gf6w8","row":"CenterCard_row__9VX0V","label":"CenterCard_label___k5JI"};